<template>
    <Head :title="__('List of feeds')"/>

    <BreezeDashboardLayout>
        <template #header>
            <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                {{ __('List of feeds') }}
            </h2>
        </template>

        <notification v-if="success" color="success">
            {{ success }}
        </notification>

        <card-component :title="__('List of feeds')" :icon="mdiListStatus" has-table
                        :header-icon="mdiPlusBoxOutline"
                        :header-text="__('Create :resource', {resource: __('Feed').toLowerCase()})"
                        @headerIconClick="$inertia.visit(route('feed-configs.create'))">
            <feed-configs-table :items="feedConfigs" :languageOptions="languageOptions"
                                :feedTypesOptions="feedTypesOptions"/>
        </card-component>
    </BreezeDashboardLayout>
</template>

<style>
</style>

<script>
import BreezeDashboardLayout from '@/Layouts/Dashboard'
import CardComponent from '@/Components/Dashboard/CardComponent'
import Notification from '@/Components/Dashboard/Notification'
import {Head, usePage} from '@inertiajs/inertia-vue3';
import {ref, reactive, computed} from 'vue'
import {
    mdiListStatus,
    mdiPlusBoxOutline
} from '@mdi/js'
import Field from '@/Components/Dashboard/Field'
import Control from '@/Components/Dashboard/Control'
import CheckRadioPicker from '@/Components/Dashboard/CheckRadioPicker'
import JbButton from '@/Components/Dashboard/JbButton'
import JbButtons from '@/Components/Dashboard/JbButtons'
import FeedConfigsTable from '@/Components/Dashboard/FeedConfigsTable'

export default {
    components: {
        BreezeDashboardLayout,
        Head,
        CardComponent,
        Notification,
        Field,
        Control,
        CheckRadioPicker,
        JbButton,
        JbButtons,
        FeedConfigsTable
    },
    props: {
        success: String,
        feedConfigs: Object,
        languageOptions: Array,
        feedTypesOptions: Array
    },
    setup() {
        return {
            mdiListStatus,
            mdiPlusBoxOutline
        }
    }
}
</script>
